// Resolves the active colour scheme honouring `<html data-theme="…">`:
//   - "light" / "dark": explicit user choice (set by the navbar switcher).
//   - "auto" or absent: follow `prefers-color-scheme` media query.
//
// `onChange(cb)` fires whenever either signal flips, so callers don't need
// to listen to both.

const mq = window.matchMedia('(prefers-color-scheme: dark)');

export function isDarkMode() {
  const theme = document.documentElement.dataset.theme;
  if (theme === 'dark')  return true;
  if (theme === 'light') return false;
  return mq.matches;
}

export function onColorSchemeChange(callback) {
  const fire = () => callback({matches: isDarkMode()});

  mq.addEventListener('change', fire);

  const observer = new MutationObserver(records => {
    if (records.some(r => r.attributeName === 'data-theme')) fire();
  });
  observer.observe(document.documentElement, {attributes: true, attributeFilter: ['data-theme']});

  return () => {
    mq.removeEventListener('change', fire);
    observer.disconnect();
  };
}
